module.exports = __webpack_public_path__ + "img/tj2.470616cf.svg";